.upload {
  margin-top: 32px;
}

.fontDropZone {
  color: var(--color-easil-black);
  margin-bottom: 16px;
}

.checkbox {
  top: 2px;
}
